import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'
import InterventionEditor from '@/routes/interventions/InterventionEditor'
import {
  interventionEditorRouteAction,
  interventionEditorRouteLoader,
} from '@/routes/interventions/InterventionEditor.route'
import { RoleRouteObject } from '@/types'

const InterventionCreatorRoute = {
  path: 'new',
  element: <InterventionEditor creating={true} />,
  loader: interventionEditorRouteLoader,
  action: interventionEditorRouteAction,
  allowedRoles: [Roles.Guest],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default InterventionCreatorRoute
